import { useMemo } from 'react'

import { Control, useWatch } from 'react-hook-form'

import { ConfirmDialog } from 'components/common'
import {
  CreateBidAllocationDtoInput,
  useGetAvailableSubDriversQuery,
  useGetDriverByCurrentUserQuery,
} from 'generated/graphql'

interface IAllocateConfirmDialogProps {
  openConfirmModal: boolean
  setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>
  onConfirm: () => void
  control: Control<CreateBidAllocationDtoInput, any>
  bookingId: number
}

const AllocateConfirmDialog = ({
  openConfirmModal,
  setOpenConfirmModal,
  onConfirm,
  control,
  bookingId,
}: IAllocateConfirmDialogProps) => {
  const driverId = useWatch({
    control,
    name: 'driverId',
  })

  const { data: driverData } = useGetDriverByCurrentUserQuery()

  const { data: availableDriversData } = useGetAvailableSubDriversQuery({
    variables: {
      bookingId,
    },
    fetchPolicy: 'cache-first',
  })

  const selectedDriverName = useMemo(() => {
    const driver = availableDriversData?.availableSubDrivers.find((d) => d.id === driverId)
    if (!driver) return ''

    const isCurrentUser = driver.id === driverData?.driverByCurrentUser?.id
    return isCurrentUser ? 'You' : driver.name
  }, [driverId, availableDriversData?.availableSubDrivers, driverData?.driverByCurrentUser?.id])

  return (
    <ConfirmDialog
      closeAfterTransition={false}
      open={openConfirmModal}
      setOpen={setOpenConfirmModal}
      onConfirm={onConfirm}
      title={'Confirm Allocation'}
      message={`Are you sure you want to allocate this booking to ${selectedDriverName}?`}
      option1='Cancel'
      option2='Allocate'
    />
  )
}

export default AllocateConfirmDialog
